import $670gB$react, { useContext, createContext } from 'react';
import { $ as $49c51c25361d4cd2$export$ee0f7cc6afcd1c18 } from './3rdPartyModules/_react-aria/overlays/dist/import-BMKLGELQ.js';

const PreventScrollContext = /*#__PURE__*/createContext(false);
const PreventScroll = ({
  isScrollEnabled,
  children
}) => {
  const isPreventScroll = useContext(PreventScrollContext);
  $49c51c25361d4cd2$export$ee0f7cc6afcd1c18({
    isDisabled: isScrollEnabled ? true : isPreventScroll
  });
  if (isPreventScroll) {
    return /*#__PURE__*/$670gB$react.createElement($670gB$react.Fragment, null, children);
  }
  return /*#__PURE__*/$670gB$react.createElement(PreventScrollContext.Provider, {
    value: true
  }, children);
};
PreventScroll.defaultProps = {
  isScrollEnabled: false
};

export { PreventScroll as P };
//# sourceMappingURL=PreventScroll-GCzwUy55.js.map
